/**
 * Define the allowed mime types for {@link TsFileUploadComponent}
 */
export type TsFileAcceptedMimeTypes
  = 'text/csv'
  | 'image/jpeg'
  | 'image/jpg'
  | 'image/png'
  | 'image/gif'
  | 'video/mp4'
  | 'video/x-flv'
  | 'video/webm'
  | 'video/quicktime'
  | 'video/mpeg'
;


/**
 * Define an array of all allowed mime types for {@link TsFileUploadComponent}
 */
export const TS_ACCEPTED_MIME_TYPES: TsFileAcceptedMimeTypes[] = [
  'text/csv',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'video/mp4',
  'video/x-flv',
  'video/webm',
  'video/quicktime',
  'video/mpeg',
];
